/**
 * Draw multiple lines of text within a bounding box.
 * @public
 * @method fillTextLines
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {Object} boundingBox - `{ left, top }` in canvas coordinates. Only the top-left corner is specified, as the text will take up as much space as it needs.
 * @param {Array[Array[String,textStyle]]} textLines - The text to be displayed.
 *                                         textStyle  = {fontSize, font, textBaseline in [top, bottom, middle, Alphabetic, Hanging], fontColor}
 * @param {FillStyle} fillStyle - The fillStyle to apply to the text.
 * @param {Number} padding - The amount of padding above/below each line in canvas units. Note this gives an inter-line spacing of `2*padding`.
 * @returns {undefined}
 */
export default function(context, boundingBox, textLines, fillStyle, padding) {
  let lineNumber = 0;
  let hasLastEndNewLine = false;
  let lastTextLength = null;
  let moveLeft = 0;

  textLines.forEach(function(textElement) {
    const text = textElement[0];
    const textStyle = textElement[1];
    const hasEndNewLine = textElement[2];

    let fontSize = textStyle.fontSize;

    const ratio = Math.max(
      Math.min(context.canvas.height / 20, fontSize) / fontSize,
      0.3
    );
    fontSize = fontSize * ratio;
    //const fontFamily = textStyle.getFontFamily();
    const fontFamily = textStyle.fontFamily;
    context.font = `${fontSize}px "${fontFamily}"`;
    context.textBaseline = textStyle.textBaseline;
    context.fillStyle = textStyle.fontColor;
    //

    if (!hasLastEndNewLine && lastTextLength) {
      moveLeft += lastTextLength.width;
    }

    context.fillText(
      text,
      boundingBox.left + padding + moveLeft,
      boundingBox.top + padding + lineNumber * (fontSize + padding)
      //boundingBox.top + lineNumber * fontSize
    );
    //

    if (hasEndNewLine) {
      lineNumber += 1;
      moveLeft = 0;
    }

    hasLastEndNewLine = hasEndNewLine;
    lastTextLength = context.measureText(text);
  });
}
